import { useCallback } from 'react';
import { AdminApiError, adminRequest } from '../admin-api';
import { c } from './board-ui';
export type BoardRequest = <T>(path: string, init?: RequestInit) => Promise<T>;
export function useBoardRequest(
  getAccessToken: () => Promise<string>,
  onAccessDenied: () => void,
): BoardRequest {
  return useCallback(
    async <T>(path: string, init?: RequestInit) => {
      try {
        return (await adminRequest(getAccessToken, `/admin/board${path}`, init)) as T;
      } catch (error) {
        if (error instanceof AdminApiError && error.status === 403) onAccessDenied();
        throw error;
      }
    },
    [getAccessToken, onAccessDenied],
  );
}
export const json = (method: string, value: unknown): RequestInit => ({
  method,
  body: JSON.stringify(value),
});
export function boardError(error: unknown) {
  return error instanceof AdminApiError
    ? error.status === 409
      ? c.conflict
      : error.code
    : c.error;
}
